import { Head } from "@inertiajs/react";
import { useTranslation } from "react-i18next";

import { AccountForm } from "@/components/settings/account-form";
import { StripeConnectForm } from "@/components/settings/stripe-connect-form";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import SettingsLayout from "@/layouts/settings_layout";
import type { Account } from "@/types";

type ConnectAccount = {
  stripe_account_id?: string | null;
  ready: boolean;
  charges_enabled: boolean;
  payouts_enabled: boolean;
  requirements_due: string[];
  disabled_reason?: string | null;
};

export default function AccountSettings({
  account,
  connect_account: connectAccount,
  stripe_configured: stripeConfigured,
}: {
  account: Account;
  connect_account: ConnectAccount | null;
  stripe_configured: boolean;
}) {
  const { t } = useTranslation();
  return (
    <SettingsLayout>
      <Head title={t("common.account")} />
      <div className="space-y-6">
        <header>
          <h1 className="text-xl font-semibold">{t("common.account")}</h1>
          <p className="text-muted-foreground text-sm">
            {t("settings.account_description")}
          </p>
        </header>
        <Card>
          <CardHeader>
            <CardTitle>{t("common.account")}</CardTitle>
          </CardHeader>
          <CardContent>
            <AccountForm account={account} />
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle>{t("connect_ui.title")}</CardTitle>
            <CardDescription>
              {connectAccount?.ready
                ? t("connect_ui.ready")
                : t("connect_ui.description")}
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            {connectAccount?.disabled_reason && (
              <p className="text-destructive text-sm">
                {t("connect_ui.restricted")}
              </p>
            )}
            <StripeConnectForm
              connected={!!connectAccount?.stripe_account_id}
              stripeConfigured={stripeConfigured}
            />
            {!stripeConfigured && (
              <p className="text-muted-foreground text-sm">
                {t("connect_ui.unavailable")}
              </p>
            )}
          </CardContent>
        </Card>
      </div>
    </SettingsLayout>
  );
}
